import { useState, useEffect, useRef } from 'react';

const updates = [
  {
    time: '10分钟前',
    tag: '明星绯闻',
    title: '某顶流男星深夜密会神秘女子，酒店同框照曝光',
    summary: '据知情人士透露，两人已在酒店共度三小时，引发粉丝热议。',
    hot: true,
  },
  {
    time: '28分钟前',
    tag: '网红内幕',
    title: '百万粉丝网红被曝假货风波，品牌方发声明切割',
    summary: '多位消费者晒出对比图，指出该网红带货产品与正品存在明显差异。',
    hot: true,
  },
  {
    time: '1小时前',
    tag: '社会事件',
    title: '某城市豪华酒店发生争议事件，现场视频网络疯传',
    summary: '涉事方尚未作出回应，网友纷纷要求公开调查结果。',
    hot: false,
  },
  {
    time: '2小时前',
    tag: '娱乐圈',
    title: '知名导演新片选角内幕曝光，多位一线演员参与竞争',
    summary: '业内人士透露，选角过程充满戏剧性，最终人选出乎意料。',
    hot: false,
  },
  {
    time: '3小时前',
    tag: '明星绯闻',
    title: '女星离婚案新进展：财产分割协议细节流出',
    summary: '据悉双方已就核心资产分配达成初步共识，预计月底官宣。',
    hot: true,
  },
  {
    time: '5小时前',
    tag: '网红内幕',
    title: '短视频平台头部主播合约到期，下一站去向成谜',
    summary: '多家平台已抛出橄榄枝，签约金额或创行业新高。',
    hot: false,
  },
  {
    time: '7小时前',
    tag: '实锤吃瓜',
    title: '热门综艺节目录制现场冲突视频曝光，节目组紧急回应',
    summary: '涉事嘉宾已删除相关社交动态，节目组表示将严肃处理。',
    hot: true,
  },
  {
    time: '9小时前',
    tag: '最新爆料',
    title: '某国际品牌中国区代言人即将换人，新代言人身份引猜测',
    summary: '据接近品牌方人士透露，更换原因与近期舆情有关。',
    hot: false,
  },
];

export default function Updates() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="updates" ref={sectionRef} className="relative py-20 md:py-28 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-flashlight-line text-[10px]"></i>
            实时快讯
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            最新 <span className="font-heading italic text-accent-400">爆料动态</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            实时追踪全网最新爆料，第一时间掌握吃瓜资讯
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-accent-500/20 transform md:-translate-x-px"></div>

          <div className="space-y-8">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-8 transition-all duration-500 ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                } ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-8' : 'md:text-left md:pl-8'} pl-8 md:pl-0`}>
                  <div className={`${i % 2 === 0 ? 'md:items-end' : 'md:items-start'} flex flex-col`}>
                    <span className="text-xs text-foreground-600 mb-1 whitespace-nowrap">{item.time}</span>
                    <div className={`flex items-center gap-2 mb-2 ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                      <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold rounded-full whitespace-nowrap ${
                        item.hot
                          ? 'bg-accent-500/15 text-accent-400 border border-accent-500/20'
                          : 'bg-secondary-100 text-secondary-400 border border-secondary-200/50'
                      }`}>
                        {item.tag}
                      </span>
                      <h3 className="text-sm font-semibold text-foreground-100 leading-snug">{item.title}</h3>
                    </div>
                    <p className="text-xs text-foreground-500 leading-relaxed max-w-md">{item.summary}</p>
                  </div>
                </div>

                <div className="absolute left-0 md:left-1/2 top-1 w-4 h-4 -translate-x-1/2 flex items-center justify-center">
                  <span className={`w-2.5 h-2.5 rounded-full ${
                    item.hot ? 'bg-accent-500 shadow-[0_0_10px_rgba(180,255,50,0.5)]' : 'bg-background-300'
                  }`}></span>
                </div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}